import React, { useState } from "react"
import {
    StepController,
    Step,
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    Label,
    Button,
    Row,
    Column,
    Color,
    Element,
    Icon,
} from "trux"
import { useHistory } from "react-router-dom"
import { DetailsForm } from "./RosterInvite/DetailsForm"

export const InviteFamilyMemberModal = (props) => {
    const [step, setStep] = useState("WhichPlayer")
    const [selected, setSelected] = useState([])
    const history = useHistory()

    const handleCloseButtonClick = (e) => {
        e.preventDefault()
        history.goBack()
    }

    const onButtonClick = (buttonId) => {
        if (!selected.includes(buttonId)) {
            setSelected((current) => [...current, buttonId])
            console.log("selected", selected)
        } else {
            setSelected((current) =>
                current.filter((button) => button !== buttonId)
            )
        }
    }

    return (
        <Modal
            className="RemoveFamily"
            open
            onShadeClick={(e) => {
                handleCloseButtonClick(e)
            }}
        >
            <StepController step={step}>
                <Step name="WhichPlayer">
                    <TitleSection onCloseClick={handleCloseButtonClick}>
                        <ModalTitle content={"Which players?"} />
                    </TitleSection>
                    <ContentSection>
                        <Column center>
                            <Label
                                center
                                type={Label.Type.Body}
                                color={Color.Charcoal40}
                                marginBottom="4"
                                content="Select which players you would like to add a family member for."
                            />
                            <Row marginBottom="8">
                                <Element
                                    marginRight="4"
                                    className={`big-button ${
                                        selected.includes("self")
                                            ? "selected"
                                            : ""
                                    }`}
                                    onClick={() => onButtonClick("self")}
                                >
                                    <Element className="contents">
                                        {selected.includes("self") && (
                                            <Element className="selected-check">
                                                <Icon
                                                    size={16}
                                                    type={Icon.Type.Check}
                                                />
                                            </Element>
                                        )}
                                        <Label
                                            width="128px"
                                            content={`Nathan Cena`}
                                        />
                                    </Element>
                                </Element>
                                <Element
                                    className={`big-button ${
                                        selected.includes("family")
                                            ? "selected"
                                            : ""
                                    }`}
                                    onClick={() => onButtonClick("family")}
                                >
                                    <Element className="contents">
                                        {selected.includes("family") && (
                                            <Element className="selected-check">
                                                <Icon
                                                    size={16}
                                                    type={Icon.Type.Check}
                                                    marginBottom="4"
                                                />
                                            </Element>
                                        )}
                                        <Label
                                            width="128px"
                                            content="Madison Cena"
                                        />
                                    </Element>
                                </Element>
                            </Row>
                        </Column>
                    </ContentSection>
                    <FooterSection>
                        <Button
                            className="button"
                            content="Continue"
                            onClick={(e) => setStep("FamilyMemberDetails")}
                        />
                    </FooterSection>
                </Step>
                <Step name="FamilyMemberDetails">
                    <TitleSection onCloseClick={handleCloseButtonClick}>
                        <ModalTitle content={"Family member details?"} />
                    </TitleSection>
                    <ContentSection>
                        <Label
                            center
                            type={Label.Type.Body}
                            color={Color.Charcoal40}
                            marginBottom="4"
                            content="Provide the contact details for the family member you would like to invite."
                        />
                        <DetailsForm />
                    </ContentSection>
                    <FooterSection>
                        <Button
                            className="button"
                            content="Send invite"
                            onClick={handleCloseButtonClick}
                        />
                    </FooterSection>
                </Step>
            </StepController>
        </Modal>
    )
}
